class PagedResponse {
  constructor(data = {}) {
    this.pageSize = data.pageSize || 1;
    this.totalItemsCount = data.totalItemsCount || 0;
    this.currentPageNumber = data.currentPageNumber || 1;
    this.lastPageNumber = data.lastPageNumber || 1;
    this.results = [];
  }

  /**
   * Set paged response data
   *
   * @param {Array} results
   */
  setResults(results) {
    this.results = results;
  }

  /**
   * Create pagination component
   *
   * @param {HTMLElement} currentPagination - current pagination html element
   * @param {HTMLElement} container - html data container
   * @param {Function} callback - callback function
   * @returns {HTMLElement} new pagination element
   */
  createPagination(currentPagination, container, callback) {
    if (
      currentPagination &&
      currentPagination.classList.contains("pagination")
    ) {
      currentPagination.parentElement.removeChild(currentPagination);
    }
    const pagination = document.createElement("div");
    pagination.classList.add("pagination");
    pagination.dataset.page = this.currentPageNumber;
    pagination.dataset.perPage = this.pageSize;
    pagination.dataset.total = this.lastPageNumber;

    const firstButton = document.createElement("span");
    firstButton.innerHTML = "«";
    firstButton.title = "First Page";

    const nextButton = document.createElement("span");
    nextButton.innerHTML = ">";
    nextButton.title = "Next Page";
    const previousButton = document.createElement("span");
    previousButton.innerHTML = "<";
    previousButton.title = "Previous Page";

    const lastButton = document.createElement("span");
    lastButton.innerHTML = "»";
    lastButton.title = "Last Page";

    const currentPage = document.createElement("span");
    currentPage.classList.add("active");
    currentPage.innerHTML = this.currentPageNumber;
    const previousPage = document.createElement("span");
    previousPage.innerHTML = this.currentPageNumber - 1;


    const dots = document.createElement("span");
    dots.innerHTML = "...";
    dots.classList.add("dots");

    const lastPageButton = document.createElement("span");
    lastPageButton.innerHTML = this.lastPageNumber;

    firstButton.addEventListener("click", (e) =>
      this.fetchCallback(e, container, 1, callback)
    );
    lastButton.addEventListener("click", (e) =>
      this.fetchCallback(e, container, this.lastPageNumber, callback)
    );
    nextButton.addEventListener("click", (e) =>
      this.fetchCallback(e, container, this.currentPageNumber + 1, callback)
    );

    previousButton.addEventListener("click", (e) =>
      this.fetchCallback(e, container, this.currentPageNumber - 1, callback)
    );
    previousPage.addEventListener("click", (e) =>
      this.fetchCallback(e, container, this.currentPageNumber - 1, callback)
    );
    lastPageButton.addEventListener("click", (e) =>
      this.fetchCallback(e, container, this.lastPageNumber, callback)
    );


    // Show first page button («)
if (this.currentPageNumber > 1) {
  pagination.appendChild(firstButton);
  pagination.appendChild(previousButton);
}
// Always show page 1
pagination.appendChild(this.createPageButton(1, this.currentPageNumber === 1, container, callback));

if (this.lastPageNumber <= 5) {
  // Show all pages if total pages <= 5
  for (let i = 2; i <= this.lastPageNumber; i++) {
    pagination.appendChild(this.createPageButton(i, this.currentPageNumber === i, container, callback));
  }
} else {
  if (this.currentPageNumber <= 3) {
    // Near the start: show first 4 pages, dots, last page
    for (let i = 2; i <= 4; i++) {
      pagination.appendChild(this.createPageButton(i, this.currentPageNumber === i, container, callback));
    }
    pagination.appendChild(dots);
    pagination.appendChild(this.createPageButton(this.lastPageNumber, this.currentPageNumber === this.lastPageNumber, container, callback));
  } else if (this.currentPageNumber >= this.lastPageNumber - 2) {
    // Near the end: show 1, dots, last 4 pages
    pagination.appendChild(dots);
    for (let i = this.lastPageNumber - 3; i <= this.lastPageNumber; i++) {
      if (i > 1) {
        pagination.appendChild(this.createPageButton(i, this.currentPageNumber === i, container, callback));
      }
    }
  } else if (this.currentPageNumber >= 4 && this.currentPageNumber <= this.lastPageNumber - 3) {
    // In the middle: show 1, dots, current-1, current, current+1, dots, last
    pagination.appendChild(dots);
    for (let i = this.currentPageNumber - 1; i <= this.currentPageNumber + 1; i++) {
      pagination.appendChild(this.createPageButton(i, this.currentPageNumber === i, container, callback));
    }
    pagination.appendChild(dots.cloneNode(true));
    pagination.appendChild(this.createPageButton(this.lastPageNumber, this.currentPageNumber === this.lastPageNumber, container, callback));
  }
}

// Show » and next buttons
if (this.currentPageNumber < this.lastPageNumber) {
  pagination.appendChild(nextButton);
  pagination.appendChild(lastButton);
}
    return pagination;
  }


  
  /**
   * Create page button element
   *
   * @param {number} pageNum - page number
   * @param {boolean} isCurrent - is current page
   * @param {HTMLElement} container - html data container
   * @param {Function} callback - callback function
   * @returns {(HTMLElement|null)} new page button element
   */
  createPageButton(pageNum, isCurrent,container,callback) {
    const pageBtn = document.createElement("span");
    pageBtn.innerHTML = pageNum;
    pageBtn.addEventListener("click", (e) =>
      this.fetchCallback(e, container, pageNum, callback)
    );
    if (isCurrent) pageBtn.classList.add("active");
    return pageBtn;
  }


  /**
   * Create inifnity scroll component
   *
   * @param {HTMLElement} currentInfinityScroll - current infinity scroll html element
   * @param {HTMLElement} container - html data container
   * @param {Function} callback - callback function
   * @returns {(HTMLElement|null)} new infinity scroll element
   */
  createInfinityScroll(currentInfinityScroll, container, callback) {
    if (
      currentInfinityScroll &&
      currentInfinityScroll.classList.contains("infinity-scroll-pagination")
    ) {
      currentInfinityScroll.parentElement.removeChild(currentInfinityScroll);
    }

    const infinityScroll = document.createElement("div");
    infinityScroll.classList.add("infinity-scroll-pagination");
    infinityScroll.dataset.page = this.currentPageNumber;
    infinityScroll.dataset.perPage = this.pageSize;
    infinityScroll.dataset.total = this.lastPageNumber;

    const nextButton = document.createElement("button");
    const arrowDown = document.createElement("i");
    nextButton.appendChild(arrowDown);
    infinityScroll.appendChild(nextButton);

    nextButton.addEventListener("click", (e) =>
      this.fetchCallback(e, container, this.currentPageNumber + 1, callback)
    );

    if (this.currentPageNumber >= this.lastPageNumber) {
      infinityScroll.style.display = "none";
    }

    return infinityScroll;
  }

  /**
   * Invoke callback when page is changed
   *
   * @param {Event} event
   * @param {HTMLElement} container
   * @param {number} page
   * @param {Function} callback
   */
  fetchCallback(event, container, page, callback) {
    event.preventDefault();
    container.dataset.page = page;
    callback();
  }

  /**
   * Generate html when no results found
   *
   * @param {string} perRow - dataset parameter per-row
   * @param {number} fallbackPerRow - if dataset per-row was not provided
   * @returns {string} html in string
   */
  generateNoResults(perRow, fallbackPerRow) {
    const perRowString = `--perRowColumn: ${parseInt(perRow) + 1}`;
    const fallbackString = `--fallbackPerRow: ${fallbackPerRow}`;
    return `
    <div class="api-response-no-results" style="${perRow ? perRowString : ""};
    ${fallbackPerRow ? fallbackString : ""}">
        Could not find any results
    </div>
    `;
  }
}

export default PagedResponse;
